import {
  DatagridConfigurable,
  List,
  TextField,
  TopToolbar,
  SelectColumnsButton,
  DateField,
  SelectInput,
  required,
  FunctionField,
  CreateButton,
  NumberField,
  useSidebarState,
} from "react-admin";

import { ListNoResultsWithFilters } from "@/components/ListNoResultsWithFilters";
import { ListPaginationByLimit } from "@/components/pagination";
import {
  FILTER_BASE_PROPS,
  FILTER_LIMIT_OPTIONS,
  FILTER_LIMITS,
} from "@/constants/filters";
import { ClientAppInput } from "@/modules/clientApps";
import { usePaymentProviderModels } from "@/modules/paymentProviderModel";

const maxWidthStyle = {
  display: "block",
  maxWidth: "15vw",
  wordBreak: "break-all",
};

const ListActions = () => (
  <TopToolbar>
    <SelectColumnsButton />
    <CreateButton />
  </TopToolbar>
);

const DEFAULT_FILTERS = {
  limit: FILTER_LIMITS[0],
};

export const TariffsList = () => {
  const [open] = useSidebarState();
  const { data: { paymentProviderModelsObject } = {} } =
    usePaymentProviderModels();

  return (
    <List
      filters={[
        <SelectInput
          key="limit"
          label="Limit"
          source="limit"
          choices={FILTER_LIMIT_OPTIONS}
          validate={required()}
          sx={{ minWidth: "224px" }}
          alwaysOn
        />,
        <ClientAppInput
          key="clientApp"
          source="clientApp"
          optionValue="id"
          {...FILTER_BASE_PROPS}
        />,
      ]}
      filterDefaultValues={DEFAULT_FILTERS}
      storeKey={false}
      pagination={<ListPaginationByLimit />}
      actions={<ListActions />}
      sort={{ field: "id", order: "DESC" }}
    >
      <DatagridConfigurable
        bulkActionButtons={false}
        omit={["createdAt", "updatedAt"]}
        className={`datagrid-scroll ${!open ? "collapsed" : ""}`}
        empty={<ListNoResultsWithFilters defaultFilters={DEFAULT_FILTERS} />}
      >
        <TextField source="id" />
        <DateField source="createdAt" showTime />
        <DateField source="updatedAt" showTime />
        <TextField source="productId" label="Product Id" sx={maxWidthStyle} />
        <NumberField
          source="price"
          options={{ style: "currency", currency: "USD" }}
        />
        <TextField source="clientApp.title" label="Client App" />
        <TextField source="publicKey" />
        <TextField source="billingStrategy" />
        <FunctionField
          source="paymentProviderId"
          render={(record: { paymentProviderId?: string }) => {
            const id = record.paymentProviderId ?? "";
            return paymentProviderModelsObject?.[id] || id;
          }}
        />
        <TextField source="refCommission" />
      </DatagridConfigurable>
    </List>
  );
};
